import { styled } from '@vw-marketing/us-components';
import React from 'react';

const StyledVersionWrapper = styled.div<any>`
  ${({ isVisible }) => `
        display: ${isVisible ? 'block' : 'none'};
    `}
`;

declare let __VERSION__: String;

interface AppVersionProps {
  appName: string;
  visible?: boolean;
}
const AppVersion: React.FC<AppVersionProps> = ({
  appName,
  visible = false,
}) => {
  if (typeof window === 'undefined') return <></>;
  return (
    <StyledVersionWrapper isVisible={visible} className="app-version-wrapper">
      Feature App Version :: {appName} :: {__VERSION__}
    </StyledVersionWrapper>
  );
};

export default AppVersion;
